function _reduced(x) {
  return x && x['@@transducer/reduced'] ? x : {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
}

module.exports = _reduced;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/src/internal/_reduced.js
// module id = 1046
// module chunks = 8